import React, { Component } from 'react'
import { Container, Table, Button, Spinner } from 'react-bootstrap'
import { withRouter } from 'react-router-dom'
import { AdminNav, Loading } from '../../helpers'
import axios from 'axios'

class RequestEditCalendar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listInComplete: false,
      inCompleteLoading: true,
      completedLoading: false,
      modalRemoveRequest : false,
      CompanyList: [],
      removeID : 999999
    }
    this.handleTableClick = this.handleTableClick.bind(this)
    this.handleRemoveRequest = this.handleRemoveRequest.bind(this)
    this.closeModal = this.closeModal.bind(this)
    this.handleModalRemoveRequest = this.handleModalRemoveRequest.bind(this)
  }
  componentDidMount() {

    let date = new Date()
    let days = date.getDate()
    if (parseInt(days) < 10) {
      days = `0${days}`
    }
    let month = parseInt(date.getMonth()) + 1
    if (parseInt(month) < 10) {
      month = `0${month}`
    }
    let year = date.getFullYear()
    let saveDate = `${year}-${month}-${days}`

    let viewAllSurveyRequestSheetByDate = fetch(`https://backend1.riceinspections.com/testAA?timeValue=${this.props.location?.state?.timeValue || saveDate}`).then((res) => {
      return res.json()
    })
    let viewAllCompany = fetch(`https://backend1.riceinspections.com/testAB`).then((res) => {
      return res.json()
    })
    Promise.all([viewAllSurveyRequestSheetByDate, viewAllCompany])
      .then((res) => {
        viewAllSurveyRequestSheetByDate = res[0]
        viewAllCompany = res[1]
        Object.values(viewAllSurveyRequestSheetByDate).map((data) => {
          Object.values(viewAllCompany).map((companyData) => {
            if (data.companyID == companyData.companyID) {
              data['companyEN'] = companyData.companyNameEN
            }
          })
        })
        this.setState({
          ...this.state,
          viewAllSurveyRequestSheetByDate: viewAllSurveyRequestSheetByDate,
          inCompleteLoading: false,
          viewAllCompany: viewAllCompany
        })
      })
  }
  handleTableClick = (e) => {
    console.log(e.target.parentElement.id)
    this.props.history.push({
      pathname: '/RequestEdit',
      state: {
        ...this.state.viewAllSurveyRequestSheetByDate[e.target.parentElement.id],
        timeShow: this.props.location.state.timeShow || new Date(),
        timeValue: this.props.location.state.timeValue || new Date()
      },
      date: this.props.location.state.timeValue || new Date(),
    })
  }


  handleModalRemoveRequest = (requestID)=>{
    this.setState({
      ...this.state,
      modalRemoveRequest : true,
      removeID : requestID,
    })
  }

  handleRemoveRequest = (requestID) => {    
    let deleteSurveyRequest = axios.post(
      'https://backend1.riceinspections.com/testJ',
      {
        data: { 'requestID': requestID },
      }
    )
    
    deleteSurveyRequest.then((res) => {
      let date = new Date()
      let days = date.getDate()
      if (parseInt(days) < 10) {
        days = `0${days}`
      }
      let month = parseInt(date.getMonth()) + 1
      if (parseInt(month) < 10) {
        month = `0${month}`
      }
      let year = date.getFullYear()
      let saveDate = `${year}-${month}-${days}`
  
      console.log(res)
      if (res.data.data == 'Success!') {
        let viewAllSurveyRequestSheetByDate = fetch(`https://backend1.riceinspections.com/testAA?timeValue=${this.props.location?.state?.timeValue || saveDate}`).then((res) => {
          return res.json()
        })
        let viewAllCompany = fetch(`https://backend1.riceinspections.com/testAB`).then((res) => {
          return res.json()
        })

        Promise.all([viewAllSurveyRequestSheetByDate, viewAllCompany])
          .then((res) => {
            viewAllSurveyRequestSheetByDate = res[0]
            viewAllCompany = res[1]
            let viewAllCompanyRaw = res[1]
            if(viewAllSurveyRequestSheetByDate){
              Object.values(viewAllSurveyRequestSheetByDate).map((data) => {
                Object.values(viewAllCompany).map((companyData) => {
                  if (data.companyID == companyData.companyID) {
                    data['companyEN'] = companyData.companyNameEN
                  }
                })
              })
              this.setState({
                ...this.state,
                viewAllSurveyRequestSheetByDate: viewAllSurveyRequestSheetByDate,
                inCompleteLoading: false,
                removeID : 999999
              })  
            }else{
              this.setState({
                ...this.state,
                viewAllSurveyRequestSheetByDate : {},
                inCompleteLoading: false,
                removeID : 999999
              })  
            }
          })
      } else {
        alert('ไม่สามารถลบได้เนื่องจากมีใบ Checkweight เรียบร้อยแล้ว')
      }
    }).catch((res) => {
      alert('error')
    })
  }
  getCompanyName(companyObj) {
    // console.log(companyObj)
    let viewAllCompany = this.state.viewAllCompany
    let outputCompany = null
    Object.values(viewAllCompany).map((companyData) => {
      if (companyData['companyNameTH'].replace(/\s/g, '').trim() == companyObj.replace(/\s/g, '').trim()) {
        // console.log(companyData['companyNameTH'].replace(/\s/g, '').trim(), companyObj.replace(/\s/g, '').trim())
        outputCompany = companyData['companyNameEN']
      }
    })
    // console.log(outputCompany)
    if (companyObj == 'ไทยฮาจำกัด') {
      outputCompany = 'THAI HA PUBLIC CO., LTD.'
    } else if (companyObj == 'ไทยฟ้า(2511)จำกัด') {
      outputCompany = 'THAI HUA (2511) CO., LTD.'
    }
    if (outputCompany) {
      return outputCompany
    } else {
      return companyObj
    }
  }
  renderDate(dateObj) {
    let dateParser = new Date(dateObj)
    let day = dateParser.getDate()
    let month = dateParser.getMonth() + 1
    let years = dateParser.getFullYear() + 543
    return `${day}/${month}/${years}`
  }
  renderAlertCompany(requestID,modalStatus) {
    if (requestID != 999999 && modalStatus == true) {  
      return <Loading mode='warningText' title='is' handleRemoveRequestID={()=>{this.handleRemoveRequest(requestID)}} closeModal={this.closeModal} requestID={requestID} />
    } else {
      return <div></div>
    }
  }
  closeModal(){
    this.setState({
      ...this.state,
      modalRemoveRequest : false,
    })
  }
  render() {
    if (!this.state.inCompleteLoading) {
      return (
        <Container>
          <AdminNav></AdminNav>
          <br></br>
          <Table bordered hover>
            <thead>
              <tr>
                <th>วันบรรทุกสินค้า</th>
                <th>Order NO.</th>
                <th>จังหวัดบรรทุก</th>
                <th>อำเภอบรรทุก</th>
                <th>สถานที่บรรทุก</th>
                <th>ชื่อบริษัท</th>
                <th>ยกเลิก</th>
              </tr>
            </thead>
            <tbody>
              {(() => {
                if (this.state.viewAllSurveyRequestSheetByDate) {
                  return Object.keys(this.state.viewAllSurveyRequestSheetByDate).map((res) => {
                    let c = this.state.viewAllSurveyRequestSheetByDate[res]
                    let orderNO = null
                    console.log(`${c.requestID}`.split('-'))
                    if(`${c.requestID}`.split('-').length > 1){
                      orderNO = `${c.requestID}`.split('-')[5]
                    }else{
                      orderNO = `${c.requestID}`
                    }              
                    if (res === 'requestCount') {
                      return null;
                    }
                    return (
                      <tr id={res}>
                        <td onClick={this.handleTableClick}>{this.renderDate(c.shippingDate)}</td>
                        <td onClick={this.handleTableClick}>{orderNO}</td>
                        <td onClick={this.handleTableClick}>{c.surveyProvince}</td>
                        <td onClick={this.handleTableClick}>{c.surveyDistrict}</td>
                        <td onClick={this.handleTableClick}>{c.surveyLocateName}</td>
                        <td onClick={this.handleTableClick}>{this.getCompanyName(c.companyID)}</td>
                        {/* <td><Button onClick={() => { this.handleRemoveRequest(c.requestID) }}> ยกเลิก </Button></td> */}
                        <td><Button onClick={() => { this.handleModalRemoveRequest(c.requestID) }}> ยกเลิก </Button></td>

                      </tr>
                    )
                  }
                  )
                }
              })()}
            </tbody>
          </Table>
          {this.renderAlertCompany(this.state.removeID,this.state.modalRemoveRequest)}
        </Container>
      )
    }
    else {
      return (<Container>
        <AdminNav></AdminNav>
        <Loading />
      </Container>)
    }
  }
}


export default withRouter(RequestEditCalendar);
